import { Search, X } from "lucide-react";
import { type FormEvent, useState } from "react";
import { useNavigate } from "react-router-dom";

interface GlobalSearchProps {
  initialValue?: string;
  onQueryChange?: (query: string) => void;
  autoFocus?: boolean;
}

export function GlobalSearch({ initialValue = "", onQueryChange, autoFocus = false }: GlobalSearchProps) {
  const [query, setQuery] = useState(initialValue);
  const navigate = useNavigate();

  const update = (value: string) => {
    setQuery(value);
    onQueryChange?.(value);
  };

  const submit = (event: FormEvent) => {
    event.preventDefault();
    if (query.trim()) navigate(`/search?q=${encodeURIComponent(query.trim())}`);
  };

  return (
    <form className="global-search" role="search" onSubmit={submit}>
      <Search size={21} strokeWidth={1.8} aria-hidden="true" />
      <input
        type="search"
        value={query}
        onChange={(event) => update(event.target.value)}
        placeholder="Найти факт, описание, логотип или файл"
        aria-label="Поиск по базе знаний"
        autoFocus={autoFocus}
      />
      {query && (
        <button type="button" className="search-clear" onClick={() => update("")} aria-label="Очистить поиск">
          <X size={18} />
        </button>
      )}
    </form>
  );
}
